import {
	useNavigate,
	useOutletContext,
	Link,
	useParams,
} from "react-router-dom";
import { useVehicles } from "../../context/VehicleContext";
import Typography from "../../components/Typography";
import Button from "../../components/Button/Button";
import SpinnerCircular from "../../components/SpinnerCircular";
import { theme } from "../../theme";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { getPlatform, getIcon } from "../../utils/socialMediaUtils";
import { getVehicleIcon, getDefaultIconProps } from "../../utils/vehicleIcons";
import { useEffect } from "react";

export default function UserProfile() {
	const { userId } = useParams();
	const { profileUser, isOwnProfile } = useOutletContext();
	const navigate = useNavigate();
	const { t } = useTranslation("userProfile");

	// Contexto de vehículos
	const { vehicles: ownVehicles, fetchVehicles, loading } = useVehicles();
	// const { userId } = useOutletContext() || {}

	// Al montar, si es nuestro perfil, cargamos desde el backend
	useEffect(() => {
		if (isOwnProfile) {
			fetchVehicles(userId);
		}
	}, [isOwnProfile, fetchVehicles, userId]);

	// Si es loading, mostramos spinner

	if (loading) {
		return (
			<LoadingContainer>
				<SpinnerCircular
					size={30}
					thickness={180}
					speed={100}
					color={theme.fill.brandMain}
					secondaryColor={theme.fill.defaultWeak}
				/>
			</LoadingContainer>
		);
	}

	// if (!profileUser) {
	//   return (
	//     <LoadingContainer>
	//       <SpinnerCircular
	//         size={30}
	//         thickness={180}
	//         speed={100}
	//         color={theme.fill.brandMain}
	//         secondaryColor={theme.fill.defaultWeak}
	//       />
	//     </LoadingContainer>
	//   )
	// }

	const vehiclesToShow = isOwnProfile
		? ownVehicles
		: profileUser.vehicles || [];

	return (
		<Profile>
			<Container>
				<UserInfo>
					<Bio>
						<Typography
							$variant="title-4-semibold"
							$variantTablet="title-5-semibold"
							$variantMobile="body-1-semibold"
							as="h3"
						>
							{/* Bio */}
							{t("profile.title")}
						</Typography>
						{!profileUser.description ? (
							isOwnProfile ? (
								<EmptyStateWrapper>
									<Typography
										$variant="body-2-regular"
										color={theme.colors.defaultWeak}
									>
										{t("profile.emptyState.noBio")}
										{/* Añade una biografía para que otros miembros de la comunidad te conozcan mejor. */}
									</Typography>
									<Button
										$variant="outline"
										onClick={() =>
											navigate(`/edit-profile`, {
												state: { returnTo: `/user/${userId}` },
											})
										}
									>
										{/* Editar perfil */}
										{t("profile.edit")}
									</Button>
								</EmptyStateWrapper>
							) : (
								<Typography
									$variant="body-2-regular"
									color={theme.colors.defaultWeak}
								>
									{/* Este usuario no tiene Bio */}
									{t("profile.emptyState.noBioPublicMsg")}
								</Typography>
							)
						) : (
							<Typography
								$variant="body-2-regular"
								color={theme.colors.defaultWeak}
							>
								{profileUser.description}
							</Typography>
						)}
						{profileUser.socialMediaLinks &&
							profileUser.socialMediaLinks.length > 0 && (
								<SocialMediaList>
									{profileUser.socialMediaLinks.map(
										(socialMediaLink, index) => {
											const platform = getPlatform(socialMediaLink.url);
											const IconComponent = getIcon(platform);

											return (
												<SocialMediaItem key={index}>
													<IconLink
														href={socialMediaLink.url}
														target="_blank"
														rel="noreferrer"
													>
														{/* <img src={icon} alt={platform} /> */}
														<IconComponent fill={theme.colors.defaultWeak} />
													</IconLink>
												</SocialMediaItem>
											);
										},
									)}
								</SocialMediaList>
							)}
					</Bio>
					{/* <Vehicles>
            {profileUser.vehicles && profileUser.vehicles.length > 0 ? (
              <>
                <VehiclesHeader>
                  <Typography $variant="title-4-semibold" as="h3">
                    {t('garage.titlePublicMsg')}
                  </Typography>
                  <Link to={`/user/${userId}/garage`}>
                    <Typography $variant="body-1-semibold" as="p" color={theme.colors.defaultStrong}>
                      {t('garage.viewGarage')}
                    </Typography>
                  </Link>
                </VehiclesHeader>
                <VehicleList>
                  {profileUser.vehicles.map(vehicle => (
                    <Vehicle key={vehicle.id}>
                      <VehicleContent>
                        <VehicleImage src={vehicle.image} alt={vehicle.brand + ' ' + vehicle.model} />
                      </VehicleContent>
                    </Vehicle>
                  ))}
                </VehicleList>
              </>
            ) : (
              // Empty state para vehículos: Si es el propio perfil, mostrar botón para añadir vehículo
              isOwnProfile ? (
                <>
                  <Typography $variant="title-4-semibold" as="h3">Garaje</Typography>
                  <EmptyStateWrapper>
                    <Typography $variant="body-2-regular" color={theme.colors.defaultWeak}>
                      {t('garage.emptyState.noVehicles')}
                    </Typography>
                    <Button $variant="outline" onClick={() => navigate(`/user/${userId}/garage`)}>
                      {t('garage.button')}
                    </Button>
                  </EmptyStateWrapper>
                </>
              ) : (
                <>
                  <Typography $variant="title-4-semibold" as="h3">Garaje</Typography>
                  <Typography $variant="body-2-regular" color={theme.colors.defaultWeak}>
                    {t('garage.emptyState.noVehiclesPublicMsg')}
                  </Typography>
                </>
              )
            )}

          </Vehicles> */}
					<Vehicles>
						{vehiclesToShow.length > 0 ? (
							<>
								<VehiclesHeader>
									<Typography
										$variant="title-4-semibold"
										$variantTablet="title-5-semibold"
										$variantMobile="body-1-semibold"
										as="h3"
									>
										{t("garage.titlePublicMsg")}
									</Typography>
									<Link to={`/user/${userId}/garage`}>
										<Typography
											$variant="body-1-medium"
											$variantMobile="body-2-medium"
											as="p"
											color={theme.colors.defaultStrong}
										>
											{t("garage.viewGarage")}
										</Typography>
									</Link>
								</VehiclesHeader>
								<VehicleList>
									{vehiclesToShow.map((vehicle) => {
										const VehicleIconComponent = getVehicleIcon(
											vehicle?.vehicleType,
										);
										const iconProps = {
											...getDefaultIconProps(theme.fill.brandMain),
											width: 40,
											height: 40,
										};
										return (
											<Vehicle key={vehicle.id}>
												<VehicleContent>
													{vehicle?.image ? (
														<VehicleImage
															src={vehicle.image}
															alt={`${vehicle.brand} ${vehicle.model}`}
														/>
													) : (
														<VehicleIconPlaceholder>
															<VehicleIconComponent {...iconProps} />
														</VehicleIconPlaceholder>
													)}
												</VehicleContent>
											</Vehicle>
										);
									})}
								</VehicleList>
							</>
						) : isOwnProfile ? (
							<>
								<Typography
									$variant="title-4-semibold"
									$variantTablet="title-5-semibold"
									$variantMobile="body-1-semibold"
									as="h3"
								>
									{t("garage.titlePublicMsg")}
								</Typography>
								<EmptyStateWrapper>
									<Typography
										$variant="body-2-regular"
										color={theme.colors.defaultWeak}
									>
										{t("garage.emptyState.noVehicles")}
									</Typography>
									<Button
										$variant="outline"
										onClick={() => navigate(`/user/${userId}/garage`)}
									>
										{t("garage.button")}
									</Button>
								</EmptyStateWrapper>
							</>
						) : (
							<>
								<Typography
									$variant="title-4-semibold"
									$variantTablet="title-5-semibold"
									$variantMobile="body-1-semibold"
									as="h3"
								>
									{t("garage.titlePublicMsg")}
								</Typography>
								<Typography
									$variant="body-2-regular"
									color={theme.colors.defaultWeak}
								>
									{t("garage.emptyState.noVehiclesPublicMsg")}
								</Typography>
							</>
						)}
					</Vehicles>
					<Achievements>
						<Typography
							$variant="title-4-semibold"
							$variantTablet="title-5-semibold"
							$variantMobile="body-1-semibold"
							as="h3"
						>
							{t("achievements.title")}
						</Typography>
						<Typography
							$variant="body-2-regular"
							color={theme.colors.defaultWeak}
						>
							{t("achievements.emptyState.comingSoon")}
						</Typography>
					</Achievements>
				</UserInfo>
			</Container>
		</Profile>
	);
}

const Profile = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  background-color: ${({ theme }) => theme.fill.defaultMain};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.md} ${({ theme }) => theme.sizing.xxxl} ${({ theme }) => theme.sizing.md};
  width: 100%;
  max-width: 1400px;
  gap: ${({ theme }) => theme.sizing.md};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.sm} ${({ theme }) => theme.sizing.xxxl} ${({ theme }) => theme.sizing.sm};
  }
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.sizing.sm};
  width: 100%;
  padding-bottom: ${({ theme }) => theme.sizing.md};
`;

const UserInfoBlock = styled.div`
  display: flex;
  border-radius: ${({ theme }) => theme.radius.xs};
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  background-color: ${({ theme }) => theme.fill.defaultMain};

  padding: ${({ theme }) => theme.sizing.sm};
  padding-top: 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.sizing.xs};
  align-self: stretch;
`;

const Bio = styled(UserInfoBlock)``;

const SocialMediaList = styled.ul`
  list-style: none;
  padding: 0;
  margin-top:  ${({ theme }) => theme.sizing.xs};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: ${({ theme }) => theme.sizing.xs};
`;

const SocialMediaItem = styled.li`
`;

const IconLink = styled.a`
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.sizing.xs};
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  border-radius: ${({ theme }) => theme.radius.xs};
  opacity: 0.8;
  cursor: pointer;

  &:hover {
    opacity: 1;
    background-color: ${({ theme }) => theme.fill.defaultSubtle};
    border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  }
`;

const Vehicles = styled(UserInfoBlock)`
  // border-top: 1px solid ${({ theme }) => theme.border.defaultSubtle};
`;

const VehiclesHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const VehicleList = styled.ul`
  // display: flex;
  // flex-direction: column;
  // align-items: flex-start;
  // gap: 8px;
  // align-self: stretch;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: ${({ theme }) => theme.sizing.xs};
  row-gap: ${({ theme }) => theme.sizing.xs};
  padding-top: ${({ theme }) => theme.sizing.xxs};
  width: 100%;
`;

const Vehicle = styled.li`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: space-between;
  // padding-right: ${({ theme }) => theme.sizing.sm};
`;

const VehicleContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.sizing.sm};
  align-self: stretch;
  width: 100%;
`;

const VehicleImage = styled.img`
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.radius.xs};
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
`;

const VehicleIconPlaceholder = styled.div`
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: ${({ theme }) => theme.radius.xs};
  background: ${({ theme }) => theme.fill.inverseWeak};
  display: flex;
  align-items: center;
  justify-content: center;
  // border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
`;

const Achievements = styled(UserInfoBlock)`
  // border-top: 1px solid ${({ theme }) => theme.border.defaultSubtle};
`;

const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.sizing.sm};
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.sizing.xl} ${({ theme }) => theme.sizing.md};
`;

// const LoaderMsg = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: center;
//   align-items: center;
//   gap: ${({ theme }) => theme.sizing.xs};
// `;
